import { Injectable, inject } from '@angular/core';
import { StorageLifecycleManager } from '@app/infrastructure/storage';
import { GOOGLE_AUTH_ADAPTER } from '../tokens/infrastructure.tokens';

/**
 * Composite bootstrap for the infrastructure layer.
 *
 * Both initializers are independent and run in parallel via Promise.all()
 * for a small startup performance gain.
 *
 * Prerequisites: RuntimeConfigService.load() must have completed before this
 * service initializes, as GoogleAuthAdapter reads config values at init time.
 */
@Injectable({ providedIn: 'root' })
export class InfrastructureBootstrapService {
  private readonly storageLifecycleManager = inject(StorageLifecycleManager);
  private readonly googleAuthAdapter = inject(GOOGLE_AUTH_ADAPTER);

  async initialize(): Promise<void> {
    await Promise.all([
      this.storageLifecycleManager.initialize(),
      this.googleAuthAdapter.initialize(),
    ]);
  }
}
